import Component from '../core/Component'
import EventBus from '../core/EventBus'

export const STATES = {
    ACTIVE: 'is-active'
}

export default class Overlay extends Component {
    prepare() {
        EventBus.on('overlay:open', this.open)
        EventBus.on('overlay:close', this.close)
        this.element.addEventListener('click', this.close)
        document.addEventListener('swup:clickLink', this.close)
    }

    destroy() {
        EventBus.off('overlay:open', this.open)
        EventBus.off('overlay:close', this.close)
        document.removeEventListener('swup:clickLink', this.close)
    }

    open = () => {
        this.element.classList.add(STATES.ACTIVE)
    }

    close = () => {
        this.element.classList.remove(STATES.ACTIVE)
    }
}